import styled from 'styled-components';

import { secondary } from '../../styles/styled/colors';

export const Wrapper = styled.div`
    display: flex;
    cursor: pointer;
`

export const DivInput = styled.div`
    background: 'white';
    padding: .7rem 1rem;
    font-weight: 400;
    border:0;
    color: ${secondary};
    outline: none;
    flex-grow: 1;
    padding-left:0px;
`;

export const TextInput = styled.input`
    background: 'white';
    padding: .7rem 1rem;
    font-weight: 400;
    border:0;
    color: ${secondary};
    outline: none;
    flex-grow: 1;
    padding-left:0px;
`;

export const ButtonWrapper = styled.div`
    float:right;
    padding: 5px 5px 0 0;
`;


// WEBPACK FOOTER //
// ./src/components/TqlQueryInput/Styled.js